
import { API, handleResponse, axiosInstance } from './helper';


interface uploadPresignedUrlPayload {
    fileKey: string;
    fileType: string;
}

const getFetchPresignedUrl = (fileKey: string) => {
    return handleResponse(
        axiosInstance.get(`${API.fetchPresignedUrl}?fileKey=${fileKey}`)
    );
}

const getUploadPresignedUrl = (upload_presigned_url_payload: uploadPresignedUrlPayload) => {
    return handleResponse(
        axiosInstance.get(`${API.uploadPresignedUrl}?fileKey=${upload_presigned_url_payload.fileKey}&fileType=${upload_presigned_url_payload.fileType}`)
    );
}


export {
    getFetchPresignedUrl,
    getUploadPresignedUrl
}